export const config = {
  POPEYE_INVITATION_CODE_ERRORS: [
    "POPEYE_INVITATION_CODE_IS_NOT_VALID",
    "BOATER_NOT_FOUND",
    "POPEYE_INVITATION_CODE_HAVE_BEEN_EXPIRED",
    "POPEYE_INVITATION_MAX_INVITATIONS"
  ]
}